import { useCurrentLocaleCode } from '@/composables/locale'

export const formatCurrency = (amount, options) =>
  new Intl.NumberFormat(useCurrentLocaleCode(), {
    style: 'currency',
    currency: 'EUR',
    ...options,
  }).format(amount)

export const formatCurrencyLeft = (value, options, currency = 'EUR') => {
  // Get the currency symbol first using Intl
  const symbol = (0)
    .toLocaleString(useCurrentLocaleCode(), {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, '')
    .trim()

  // Format the number only
  const number = new Intl.NumberFormat(useCurrentLocaleCode(), {
    ...options,
  }).format(value)

  return `${symbol}${number}`
}
